import clsx from 'clsx'
import page from '@/pages/NewDeploymentPage.module.css'

interface TextFieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  required?: boolean
  type?: 'text' | 'password' | 'number'
  placeholder?: string
  hint?: string
  /** A validation message. Shown under the field and announced. */
  problem?: string | null
  maxLength?: number
  /** For a number field: the smallest and the largest value. */
  min?: number
  max?: number
  autoComplete?: string
  disabled?: boolean
  onBlur?: () => void
}

/** A labelled input with a hint and an error message, wired up for screen readers. */
export function TextField({ id, label, value, onChange, required, type = 'text', placeholder, hint, problem, maxLength, min, max, autoComplete, disabled, onBlur }: TextFieldProps) {
  const describedBy = `${id}-desc`
  return (
    <div className={page.formGroup}>
      <label htmlFor={id} className={page.label}>
        {label} {required && <span className={page.required}>*</span>}
      </label>
      <input
        id={id}
        className={clsx(page.input, problem && page.inputError)}
        type={type}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
        max={max}
        autoComplete={autoComplete}
        disabled={disabled}
        aria-describedby={describedBy}
        aria-invalid={problem ? true : undefined}
        aria-required={required || undefined}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
      />
      <div id={describedBy}>
        {problem ? (
          <span role="alert" className={page.errorMsg}>
            {problem}
          </span>
        ) : hint ? (
          <span className={page.fieldHint}>{hint}</span>
        ) : null}
      </div>
    </div>
  )
}
